import { render, staticRenderFns } from "./helpDoc.vue?vue&type=template&id=4c57ea50&scoped=true&"
import script from "./helpDoc.vue?vue&type=script&lang=js&"
export * from "./helpDoc.vue?vue&type=script&lang=js&"
import style0 from "./helpDoc.vue?vue&type=style&index=0&id=4c57ea50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c57ea50",
  null
  
)

export default component.exports